module.exports = __webpack_public_path__ + "img/user1.36c79028.png";